exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kb-video-header {\r\n    color: rgba(0, 0, 0, 0.87);\r\n    margin: 5px;\r\n    letter-spacing: 0.3px;\r\n    text-align: center;\r\n}\r\n\r\nimg{\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.videoBox {\r\n    min-width: 33%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-video-panel/djiv-video-panel.component.css
// module id = ../../../../../src/app/shared/components/djiv-video-panel/djiv-video-panel.component.css
// module chunks = main